import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useLang } from "../../lib/i18n";

export const HeroVisual = ({ scrollY }) => {
  const { t } = useLang();
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 80, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 80, damping: 18 });
  const imgY = useTransform(scrollY, [0, 800], [-30, 60]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };

  return (
    <div onMouseMove={onMove} onMouseLeave={() => { mx.set(0); my.set(0); }} className="relative w-full h-full [perspective:1400px]" data-testid="hero-visual">
      <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative mx-auto h-full w-full max-w-[460px]">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.4, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
          style={{ z: -120 }}
          className="absolute left-0 top-[22%] h-[72%] w-[50%] rounded-[36px] bg-[#0F8A78]/30"
        />
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.4, delay: 0.75, ease: [0.22, 1, 0.36, 1] }}
          style={{ z: -60 }}
          className="absolute left-[12%] top-[11%] h-[76%] w-[50%] rounded-[36px] bg-[#0F8A78]/60"
        />
        <motion.div
          initial={{ clipPath: "inset(100% 0% 0% 0% round 36px)" }}
          animate={{ clipPath: "inset(0% 0% 0% 0% round 36px)" }}
          transition={{ duration: 1.5, delay: 0.5, ease: [0.76, 0, 0.24, 1] }}
          style={{ z: 40 }}
          className="absolute right-0 top-0 h-[80%] w-[62%] overflow-hidden rounded-[36px] bg-[var(--teal)] shadow-[0_40px_120px_-30px_rgba(15,138,120,0.7)]"
        >
          <motion.img style={{ y: imgY, scale: 1.35 }} src="/images/hero-pellets.jpg" alt="Rice husk biomass pellets under a spotlight" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#071a15]/70 via-transparent to-transparent" />
          <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
            <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-[var(--cream)]">HuskFire · 6 mm</span>
            <span className="font-serif-i text-2xl text-[var(--husk)]">{t("hero.nobinder")}</span>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};
